(function ($) {
	'use strict';

	$(function () {
		const $triggers = $('.js-newsletter-anchor');

		$triggers.each(function () {
			const $trigger = $(this);
			const $form = $('#newsletter-form');
			const $input = $form.find('input:visible:enabled').first();

			const timeout = 550; // wait for css animation to finish

			$trigger.on('click', function () {
				setTimeout(function () {
					$input.trigger('focus');
				}, timeout);

				$([document.documentElement, document.body]).animate({
					scrollTop: $form.offset().top
				}, 500);
			});
		});
	});
})(jQuery);